var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8334 2.43457C15.606 2.43457 15.3808 2.47937 15.1706 2.56641C14.9605 2.65346 14.7695 2.78103 14.6087 2.94187L3.47607 14.0745L2.55752 17.4425L5.92552 16.524L17.0582 5.39132C17.219 5.23048 17.3466 5.03955 17.4336 4.82941C17.5207 4.61927 17.5655 4.39405 17.5655 4.16659C17.5655 3.93914 17.5207 3.71391 17.4336 3.50378C17.3466 3.29364 17.219 3.1027 17.0582 2.94187C16.8973 2.78103 16.7064 2.65346 16.4962 2.56641C16.2861 2.47937 16.0609 2.43457 15.8334 2.43457ZM14.6923 1.41156C15.0541 1.2617 15.4418 1.18457 15.8334 1.18457C16.225 1.18457 16.6128 1.2617 16.9746 1.41156C17.3364 1.56142 17.6651 1.78108 17.942 2.05798C18.2189 2.33489 18.4386 2.66363 18.5885 3.02542C18.7383 3.38722 18.8155 3.77499 18.8155 4.16659C18.8155 4.5582 18.7383 4.94597 18.5885 5.30776C18.4386 5.66956 18.2189 5.9983 17.942 6.2752L6.69204 17.5252C6.61513 17.6021 6.51948 17.6576 6.41454 17.6862L1.83121 18.9362C1.61483 18.9953 1.38341 18.9338 1.22482 18.7752C1.06623 18.6166 1.00477 18.3852 1.06379 18.1688L2.31379 13.5855C2.3424 13.4805 2.39791 13.3849 2.47482 13.308L13.7248 2.05798C14.0017 1.78108 14.3305 1.56142 14.6923 1.41156Z",
  fill: "white"
});

function SvgEdit2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.9e5a485b.svg";
export { ForwardRef as ReactComponent };